// Utils
import { getUrlUtils } from '@shopee-user/common-url';

// Constants
import {
  HOMEPAGE,
  SHOPEE_PAY_LEGACY_LOGIN_BY_PASSWORD,
  SHOPEE_PAY_LEGACY_USER_PASSWORD,
  LOGIN_BY_PASSWORD,
  LOGIN_BY_OTP,
  LOGIN_BY_TOKEN,
  LOGIN_BY_NO_COST_AUTHENTICATION,
  LOGIN_BY_IVS,
  LOGIN_BY_THIRD_PARTY,
  SIGNUP_BY_OTP,
  RESET_PASSWORD,
  RESET_PASSWORD_FROM_LINK,
  USER,
  USER_ACCOUNT,
  USER_PASSWORD,
  USER_EMAIL,
  USER_PHONE,
  ACCOUNT_ONE_CREDENTIAL_MIGRATION,
  ACCOUNT_ONE_CREDENTIAL_SWITCH_TOC_LINK,
  VERIFY_OTP,
  VERIFY_PASSWORD,
  ACCEPT_INVITATION,
  CONFIG,
  USER_CREDENTIALS_COMMIT,
  ACCOUNT_ONE_CREDENTIAL_DELINK,
  USER_ACCOUNT_LINKAGE,
  LOGIN_BY_TOKEN_TOB_ONE_CREDENTIAL,
  IVS_SHARED_SERVICE,
  THIRD_PARTY_AUTHENTICATION_SERVICE,
  POST_AUTHENTICATION_SERVICE,
  RELOGIN_PAGE,
  NO_COST_AUTH_ACTIVATION_SHARED_SERVICE,
  LOGOUT_SHARED_SERVICE,
} from './routes';

export const shopeePayLegacyLoginByPassword = getUrlUtils(
  SHOPEE_PAY_LEGACY_LOGIN_BY_PASSWORD
);
export const loginByPasswordURL = getUrlUtils(LOGIN_BY_PASSWORD);
export const loginByOTPURL = getUrlUtils(LOGIN_BY_OTP);
export const loginByToken = getUrlUtils(LOGIN_BY_TOKEN);
export const loginByTokenTobOneCredential = getUrlUtils(
  LOGIN_BY_TOKEN_TOB_ONE_CREDENTIAL
);
export const loginByNoCostAuthenticationURL = getUrlUtils(
  LOGIN_BY_NO_COST_AUTHENTICATION
);
export const reloginPageURL = getUrlUtils(RELOGIN_PAGE);
export const loginByIvsURL = getUrlUtils(LOGIN_BY_IVS);
export const loginByThirdParty = getUrlUtils(LOGIN_BY_THIRD_PARTY);
export const signupByOTPURL = getUrlUtils(SIGNUP_BY_OTP);
export const resetPasswordURL = getUrlUtils(RESET_PASSWORD);
export const resetPasswordFromLinkURL = getUrlUtils(RESET_PASSWORD_FROM_LINK);
export const userAccountURL = getUrlUtils(USER_ACCOUNT);
export const changePasswordURL = getUrlUtils(USER_PASSWORD);
export const userEmail = getUrlUtils(USER_EMAIL);
export const userPhoneURL = getUrlUtils(USER_PHONE);
export const userAccountLinkage = getUrlUtils(USER_ACCOUNT_LINKAGE);
export const verifyOtpUrl = getUrlUtils(VERIFY_OTP);
export const verifyPasswordUrl = getUrlUtils(VERIFY_PASSWORD);
export const acceptInvitation = getUrlUtils(ACCEPT_INVITATION);
export const accountOneCredentialMigration = getUrlUtils(
  ACCOUNT_ONE_CREDENTIAL_MIGRATION
);
export const accountOneCredentialSwitchToCLink = getUrlUtils(
  ACCOUNT_ONE_CREDENTIAL_SWITCH_TOC_LINK
);
export const accountOneCredentialDelink = getUrlUtils(
  ACCOUNT_ONE_CREDENTIAL_DELINK
);
export const ivsSharedService = getUrlUtils(IVS_SHARED_SERVICE);
export const postLoginService = getUrlUtils(POST_AUTHENTICATION_SERVICE);
export const noCostAuthActivationSharedService = getUrlUtils(
  NO_COST_AUTH_ACTIVATION_SHARED_SERVICE
);
export const logoutSharedServiceURL = getUrlUtils(LOGOUT_SHARED_SERVICE);

export const ROUTES = {
  HOMEPAGE,
  SHOPEE_PAY_LEGACY_LOGIN_BY_PASSWORD,
  SHOPEE_PAY_LEGACY_USER_PASSWORD,
  LOGIN_BY_PASSWORD,
  LOGIN_BY_OTP,
  LOGIN_BY_TOKEN,
  LOGIN_BY_NO_COST_AUTHENTICATION,
  LOGIN_BY_IVS,
  LOGIN_BY_THIRD_PARTY,
  SIGNUP_BY_OTP,
  RESET_PASSWORD,
  RESET_PASSWORD_FROM_LINK,
  USER,
  USER_ACCOUNT,
  USER_PASSWORD,
  USER_EMAIL,
  USER_PHONE,
  VERIFY_OTP,
  VERIFY_PASSWORD,
  ACCEPT_INVITATION,
  ACCOUNT_ONE_CREDENTIAL_MIGRATION,
  ACCOUNT_ONE_CREDENTIAL_SWITCH_TOC_LINK,
  CONFIG,
  USER_CREDENTIALS_COMMIT,
  ACCOUNT_ONE_CREDENTIAL_DELINK,
  USER_ACCOUNT_LINKAGE,
  LOGIN_BY_TOKEN_TOB_ONE_CREDENTIAL,
  IVS_SHARED_SERVICE,
  THIRD_PARTY_AUTHENTICATION_SERVICE,
  POST_AUTHENTICATION_SERVICE,
  RELOGIN_PAGE,
  NO_COST_AUTH_ACTIVATION_SHARED_SERVICE,
  LOGOUT_SHARED_SERVICE,
};

// Enums
export enum PageName {
  Homepage = 'Homepage',
  PageUser = 'PageUser',
  PageLoginByPassword = 'PageLoginByPassword',
  PageLoginByOTP = 'PageLoginByOTP',
  PageLoginByToken = 'PageLoginByToken',
  PageLoginByNoCostAuthentication = 'PageLoginByNoCostAuthentication',
  PageLoginByQuickLogin = 'PageLoginByQuickLogin',
  PageLoginByBiometric = 'PageLoginByBiometric',
  PageLoginByIvs = 'PageLoginByIvs',
  PageLoginByThirdParty = 'PageLoginByThirdParty',
  PageSignupByOTP = 'PageSignupByOTP',
  PageResetPassword = 'PageResetPassword',
  PageUserPassword = 'PageUserPassword',
  PageUserAccount = 'PageUserAccount',
  PageUserEmail = 'PageUserEmail',
  PageUserPhone = 'PageUserPhone',
  PageUserAccountLinkage = 'PageUserAccountLinkage',
  PageVerifyOtp = 'PageVerifyOtp',
  PageVerifyPassword = 'PageVerifyPassword',
  PageAcceptInvitation = 'PageAcceptInvitation',
  PageAccountOneCredentialMigration = 'PageAccountOneCredentialMigration',
  PageAccountOneCredentialSwitchToCLink = 'PageAccountOneCredentialSwitchToCLink',
  PageAccountOneCredentialDelink = 'PageAccountOneCredentialDelink',
  PageUserCredentialsCommit = 'PageUserCredentialsCommit',
  PageLoginByTokenTobOneCredential = 'PageLoginByTokenTobOneCredential',
  PageIvsSharedService = 'PageIvsSharedService',
  PageThirdPartyAuth = 'PageThirdPartyAuth',
  PageThirdPartyService = 'PageThirdPartyService',
  PagePostAuthenticationService = 'PagePostAuthenticationService',
  PageReloginPage = 'PageReloginPage',
  PageNoCostAuthActivationSharedService = 'PageNoCostAuthActivationSharedService',
  PageLogoutSharedService = 'PageLogoutSharedService',
  Page404 = 'Page404',
  Unknown = 'Unknown',
}

export { getPathRelativeToBasePath } from './utils';
